import React from 'react';

export default function ClockDisplay (props) {
    let hours = Math.abs(Math.floor(props.timeInMinutes / 60)).toString().padStart(2, '0');
    let minutes = Math.abs(Math.round(props.timeInMinutes % 60)).toString().padStart(2, '0');

    if (!props.timeInMinutes) { hours = minutes = '--'; }

    return (
        <article className='clock-display'>
            <div className='label'>
                {props.label}
            </div>

            <div className='value'>
                <strong className='time'>
                    {hours}
                    <span>:</span>
                    {minutes}
                </strong>
                <small className='d-flex justify-content-center'>
                    <span className='mr-2'>HR</span>
                    <span className='ml-2'>MIN</span>
                </small>
            </div>
        </article>
    );
}
